/* eslint-disable import/prefer-default-export */

/**
 * @deprecated use data?.[locale] instead
 */
export const getProductTranslatedData = (data, locale) => {
  return data?.[locale];
};
